export default __webpack_public_path__ + "static/media/error-page.1501b851.png";